import { render, staticRenderFns } from "./RelatedPartyList.vue?vue&type=template&id=3b28409c"
import script from "./RelatedPartyList.vue?vue&type=script&lang=js"
export * from "./RelatedPartyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports